import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { CovidService } from '../../covid.service';
import { Covidcategories } from '../../interfaces/covid.categories';
import { forkJoin } from 'rxjs';
import { Countries } from '../../interfaces/countries';
import { MatDialog } from '@angular/material/dialog';
import { DialogMapComponent } from '../dialog-map/dialog-map.component';

@Component({
  selector: 'app-articles-sidenav',
  templateUrl: './articlessidenav.component.html',
  styleUrls: ['./articlessidenav.component.less']
})
export class ArticlessidenavComponent implements OnInit, OnChanges {
  @Output() searchByCategory = new EventEmitter();
  @Output() searchByCountry = new EventEmitter();
  @Input() currentSearch;
  @Input() worldCountries;


  categories: Covidcategories;
  countries: Countries;
  mapCountries = null;
  currentCategory = 'All';
  chartData = null;
  loading = true;
  margin = {top: 30, right: 0, bottom: 30, left: 40};
  width = 200;
  height = 200;
  chartType = [
    {value: 1, name: 'Weeks'},
    {value: 2, name: 'Months'}
  ];
  publicationType = 1;
  constructor(private covid: CovidService,
              public dialog: MatDialog) { }

  ngOnInit(): void {
    this.getCategories();
    this.getCountries();
    this.getDataWeeks();
  }

  ngOnChanges(change) {
    const { currentSearch, worldCountries } = change;
    if (currentSearch && currentSearch.currentValue ) {
      if (currentSearch.currentValue === ('Author' || 'Abstract' || 'Title')) {
          this.currentCategory = null;
      }
    }
  }

  getCategories() {
    this.covid.getCovidCategories().subscribe((response: any) => {
      let total = 0;
      const categories = response.map((item: Covidcategories) => {
        total = total + item.total;
        return this.covid.formatCategories(item);
      });
      categories.unshift({category: 'All', total, uid: null});
      this.categories = categories;
    });
  }

  getCountries() {
    this.covid.getCovidCountries().subscribe((response: Countries) => {
      this.countries = response;
    });
  }

  getCategory({category, uid}) {
    this.currentCategory = category;
    this.searchByCategory.emit({category, uid});
  }

  getCountry({country}) {
    this.currentCategory = country;
    this.searchByCountry.emit(country);
  }

  getDataWeeks() {
    forkJoin({
      monthLabels: this.covid.getMonthLabels(),
      weekLabels: this.covid.getWeekLabels(),
      weeksPeriod: this.covid.getWeeks(),
      monthsPeriod: this.covid.getMonth()
    })
    .subscribe(({monthLabels, weekLabels, weeksPeriod, monthsPeriod}) => {
      const weekly = [['Week', 'Total']];
      const montly = [['Month', 'Total']];
      const weeks = this.covid.formatDataChart('week', weeksPeriod, weekLabels, weekly);
      const months =  this.covid.formatDataChart('month', monthsPeriod, monthLabels, montly);
      this.chartData = { weeks, months };
    });
  }

  getLoading(event) {
    setTimeout(_ => {
      this.loading = event;
    }, 200);
  }

  openModal(): void {
    const dialogRef = this.dialog.open(DialogMapComponent, {
      width: '60%',
      data: this.covid.getMapData()
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }




}
